// extracted by mini-css-extract-plugin
export default {"card":"b1gBk7","image":"c1gBk7","imageLoader":"d1gBk7","header":"e1gBk7","content":"f1gBk7","description":"g1gBk7","link":"h1gBk7"};